import Device from './device'
import System from './system'
import User from './user'
import Diy from './diy'
import Plugin from './plugin'
import Wechat from './wechat'
import Files from './files'
import institution from './institution'
import Order from './order'
import Rights from './rights'
import DidiAlarm from './didiAlarm'
import Staff from './staff'
import Shop from './shop'
import Message from './message'
import Distribution from './distribution'
import Finance from './finance'
import Article from './article'
import SaasAgent from './saas_agent'

export default [
  ...Device,
  ...User,
  ...System,
  ...Diy,
  ...Plugin,
  ...Wechat,
  ...Files,
  ...institution,
  ...Order,
  ...Rights,
  ...DidiAlarm,
  ...Staff,
  ...Shop,
  ...Message,
  ...Distribution,
  ...Finance,
  ...Article,
  ...SaasAgent
]



// WEBPACK FOOTER //
// ./src/router/apply/index.js